module.exports = __webpack_public_path__ + "img/Enovos_120X35.0ab17c29.png";